// extracted by mini-css-extract-plugin
export var root = "Swatch-module--root--b289f";
export var circle = "Swatch-module--circle--62e5e";
export var isActive = "Swatch-module--isActive--3d559";